import { Dispatch, SetStateAction } from "react";
import { TargetPlatform } from "../../../shared/types/TargetPlatform";
import { ToolsPanelFilterSelect } from "./ToolsPanelFilterSelect";

type TargetPlatformFilterSelectProps = {
    id: string;
    selectedTargetPlatformFilter: TargetPlatform | null;
    setSelectedTargetPlatformFilter: Dispatch<SetStateAction<TargetPlatform | null>>;
    availableTargetPlatforms: ReadonlySet<TargetPlatform>;
};

export function TargetPlatformFilterSelect({
    id,
    selectedTargetPlatformFilter,
    setSelectedTargetPlatformFilter,
    availableTargetPlatforms,
}: TargetPlatformFilterSelectProps) {
    const options = [
        { value: '', label: 'All platforms' },
        { value: 'None', label: 'None', disabled: !availableTargetPlatforms.has(TargetPlatform.None) },
        { value: 'Binance', label: 'Binance', disabled: !availableTargetPlatforms.has(TargetPlatform.Binance) },
        { value: 'Deribit', label: 'Deribit', disabled: !availableTargetPlatforms.has(TargetPlatform.Deribit) },
        { value: 'SamsungWallet', label: 'Samsung Wallet', disabled: !availableTargetPlatforms.has(TargetPlatform.SamsungWallet) },
        { value: 'TrustWallet', label: 'Trust Wallet', disabled: !availableTargetPlatforms.has(TargetPlatform.TrustWallet) },
        { value: 'RevolutX', label: 'RevolutX', disabled: !availableTargetPlatforms.has(TargetPlatform.RevolutX) },
    ];

    const handleChange = (value: string): void => {
        setSelectedTargetPlatformFilter(value === ''
            ? null
            : TargetPlatform[value as keyof typeof TargetPlatform]);
    };

    return (
        <ToolsPanelFilterSelect
            id={id}
            value={selectedTargetPlatformFilter === null ? '' : TargetPlatform[selectedTargetPlatformFilter]}
            options={options}
            isFilterApplied={selectedTargetPlatformFilter !== null}
            fallbackLabel="All platforms"
            onChange={handleChange}
            width={142}
        />
    );
}
